













































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwCountryIcon } from '@libs-uuif/shared/sw-country-icon';
import { SwSelect } from '@libs-uuif/shared/sw-select';
import Component from 'vue-class-component';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { Prop } from 'vue-property-decorator';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';

const cssPrefix = 'generic-modal';
@Component({
  components: {
    SwCountryIcon,
    SwSelect,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwTextfield,
  },
})
export default class GenericModal extends SwExtendedVue {
  cssPrefix = cssPrefix;
  display2 = true;
  @Prop({ required : true })
  modalObject : any;
  modalTitle = '';
  fieldNames = [];
  textDateValue = [];
  buttons = [];
  value1 = '';
  requiredField = [];
  showError : boolean = false;
  created() {
    if (this.modalObject.hasOwnProperty('modalTitle')) {
      this.modalTitle = this.modalObject.modalTitle;
      this.fieldNames = this.modalObject.fieldName;
      this.textDateValue =  this.modalObject.dataValue;
      this.buttons =  this.modalObject.buttonName;
      this.requiredField = this.modalObject.requiredField;
      console.warn(this.textDateValue);
      console.warn(this.modalObject);
    }
  }
  closeDialog() {
    this.$emit('close-modal');
  }
  buttonClicked(field : any) {
    this.showError = false;
    const obj = {
      textDateValue : this.textDateValue,
      buttonIndex : field,
      noSubmit : false,
    };
    this.textDateValue.forEach((ele : any, ind : any) => {
      if (this.requiredField[ind] && ele === '') {
        this.showError = true;
        obj.noSubmit = true;
      }
    });
    this.$emit('button-clicked', obj);
  }
}
